module.exports = __webpack_public_path__ + "static/hitch22-5c7012db15aead1e44213a870bdbf35a.jpg";